import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './i18n';
import App from './App';

const rootElement = document.getElementById('root') as HTMLElement;
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  // Pre-rendered HTML exists — hydrate to attach event listeners
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  // No pre-rendered content — full client render
  ReactDOM.createRoot(rootElement).render(app);
}
